import * as flt from "../operations/filter";
import {find, findIndex} from "../helpers/array";
import {getSheet} from "../sheets";

export function setCellFilter(row, column, filter, page){
	page = page || this.getActiveSheet();

	let sheet;
	if(page != this.getActiveSheet()){
		sheet = getSheet(this, page);
		if(!sheet) return;
	}

	filter = prepareFilter(this, row, column, filter, sheet);
	let value;

	if(sheet){
		if(!sheet.content.filters)
			sheet.content.filters = [];

		const index = findIndex(sheet.content.filters, arr => arr[0] == row && arr[1] == column);
		if(index != -1){
			value = sheet.content.filters[index][2];
			sheet.content.filters.splice(index, 1);
		}
		else if(!filter) return;

		if(filter)
			sheet.content.filters.push([row, column, filter]);
	}
	else{
		const line = this._table._ssFilters[row] = this._table._ssFilters[row] || {};
		value = line[column] || null;
		line[column] = filter;

		if (filter && typeof filter == "object"){
			this._table.addCellCss(row, column, "ss_filter");
			if (filter.value && flt.isValueActive(filter.value))
				this._table.addCellCss(row, column, "ss_filter_active");

			webix.extend(filter, {row, column}, true);

			if (!filter.handler && filter.value && filter.value.condition){
				const mode = filter.mode || flt.getFilterMode(this, row, column);
				filter.handler = flt.getFilterFunction(mode, filter.value);
			}
		} else {
			delete this._table._ssFilters[row][column];
			this._table.removeCellCss(row,column, "ss_filter");
			this._table.removeCellCss(row,column, "ss_filter_active");
		}
	}
	this.callEvent("onAction", ["filter", { row, column, value, newValue:filter, page }]);
}

function prepareFilter(view, row, column, filter, sheet){
	if(filter){
		if (webix.isArray(filter) || typeof filter == "string")
			filter = {options: filter};
		filter.options = flt.calibrateRange(view, row, column, filter.options, null, sheet);
	}
	return filter;
}

export function getCellFilter(row, column, page){
	if(page && page != this.getActiveSheet()){
		const sheet = getSheet(this, page);
		if(sheet && sheet.content.filters)
			return find(sheet.content.filters, arr => arr[0] == row && arr[1] == column) || null;
	}
	else{
		let line = this._table._ssFilters[row] || {};
		return line[column];
	}
	return null;
}

export function removeFilters(page){
	if(page && page != this.getActiveSheet()){
		const sheet = getSheet(this, page);
		if(sheet && sheet.content.filters){
			for(let i = 0; i < sheet.content.filters.length; i++){
				const filter = sheet.content.filters[i];
				this.callEvent("onAction", ["filter", { row: filter[0], column: filter[1], value: filter[2], newValue: null, page:page||this.getActiveSheet() }]);
			}
			sheet.content.filters = [];
		}
	}
	else{
		const filters = flt.getFilters(this._table);

		for	(let i=0; i<filters.length; i++){
			const {row, column} = filters[i];
			this.setCellFilter(row, column, null);
		}

		this._table._ssFilters = {};
		this._table.data.filter((obj) => {
			return this.isRowVisible(obj.id);
		});
	}
}


export function filterSpreadSheet(){
	const grid = this._table;
	grid.data.silent(()=>{
		// hidden rows
		grid.data.filter(obj => this.isRowVisible(obj.id));

		const filters = flt.getFilters(grid);
		for (let i = 0; i < filters.length; i++){
			const {row, column, handler, lastRow} = filters[i];

			let finished = false;
			grid.data.filter(obj => {
				let r = obj.id;
				if(r <= row || typeof handler != "function")
					return true;

				const span = grid.getSpan(r, column);
				if(span){
					if(span[0] == row && span[1] == column)
						return true;
					else
						r = span[0];
				}

				const value = String(this.getCellValue(r, column, false));

				if(lastRow){
					if(r > lastRow)
						return true;
				}
				else if(finished || !value)
					return finished = true;

				return handler(value);
			}, 1, true);
		}
	});

	grid.callEvent("onAfterFilter", []);
	grid.refresh();
}
